import React, { useState, useEffect } from "react";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse from "html-react-parser";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import getColor from "@insite/mobius/utilities/getColor";

const enum fields {
    richText = "richText",
    showOnLoad = "showOnLoad",
}

interface Props extends WidgetProps {
    fields: {
        [fields.richText]: string;
        [fields.showOnLoad]: boolean;
    };
}

const HeaderNotification: React.FC<Props> = (props) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (props.fields.showOnLoad) {
            setVisible(true);
        }
    }, [props.fields.showOnLoad]);

    if (!visible) return null;

    const wrapperStyles = {
        css: css`
            background-color: ${getColor("secondary")};
            position: relative;
            display: flex;
            align-items: center;
        `,
    };

    const closeIconStyles = {
        css: css`
            position: absolute;
            top: 0.6rem;
            right: 0.5rem;
            cursor: pointer;
            width: 16px;
            height: 13px;
            color: ${getColor("text.main")};
            font-family: FontAwesome6Pro-Solid;
            font-size: 12px;
            font-weight: 900;
            font-style: solid;
            text-align: center;
        `,
    };

    const notificationTextStyles = {
        css: css`
            flex: 1;
            height: 33px;
            padding-top: 5px;
            `,
    };

    return (
        <StyledWrapper {...wrapperStyles}>
            <StyledWrapper {...notificationTextStyles}>
                {parse(props.fields.richText, parserOptions)}
            </StyledWrapper>
            <Icon src={X} {...closeIconStyles} onClick={() => setVisible(false)} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: HeaderNotification,
    definition: {
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.richText,
                editorTemplate: "RichTextField",
                displayName: "Notification Text",
                defaultValue: "",
                extendedConfig: { height: 100 },
            },
            {
                fieldType: "General",
                name: fields.showOnLoad,
                editorTemplate: "CheckboxField",
                displayName: "Show on Page Load",
                defaultValue: true,
            },
        ],
        group: "Header",
    },
};

export default widgetModule;
